<script lang="ts">
    import {jwt, logout, jwtPayload} from "../Auth"
    import {route, routes} from '../Nav'
    let mdWidth = 576
    let expanded: boolean = false
    let collapsable: boolean = window.innerWidth <= mdWidth

    $: userRoles = $jwtPayload?.owner?.role ?? []
    $: isQrExportOnly = userRoles.includes('qr_export') && !userRoles.includes('admin')
    $: isManagerOnlyRu = userRoles.includes('manager_only_ru') && !userRoles.includes('admin')
    $: visibleRoutes = routes.filter(r => r.mainMenu
        && (!isQrExportOnly || r.id === 'QrLogin')
        && (!isManagerOnlyRu || r.id === 'Users'))
</script>
<svelte:window on:resize={()=>collapsable = window.innerWidth <= mdWidth}/>
<div class="navbar navbar-expand-sm navbar-dark bg-dark position-sticky sticky-top">
    <button class="navbar-toggler" on:click|preventDefault|stopPropagation={()=>expanded=!expanded}>
        <i class="navbar-toggler-icon"></i>
    </button>
    {#if !collapsable || expanded}
        <div class="navbar-collapse">
            <nav class="navbar-nav w-100">
                {#if $jwt}
                    {#each visibleRoutes as item}
                        <a class="nav-link mx-2"
                           href="#{item.hash()}"
                           class:active={item.id == $route.id}
                           on:click|preventDefault|stopPropagation={()=>location.hash=item.hash()}>{item.label}</a>
                    {/each}
                    <div class="flex-grow-1 text-end">
                        <a class="nav-link mx-2 d-inline-block"
                           href="#logout"
                           on:click|preventDefault|stopPropagation={logout}>Вийти</a>
                    </div>
                {/if}
            </nav>
        </div>
    {/if}
</div>
